import { IHallBookingBill } from "src/domain/entities"
import { hallBookingBillUpdateApi } from "../../api/hallBookingBill/hallBookingBillUpdateApi"

type PayloadShape = Parameters<typeof hallBookingBillUpdateApi>[0]

export async function hallBookingBillUpdateService(
	payload: PayloadShape,
	token?: null | string,
) {
	const hallBookingBill = await hallBookingBillUpdateApi(payload, token)
	return hallBookingBill as NonNullable<IHallBookingBill>
}
